import { useQuery } from "react-query";
import { fetcher } from "@weezevent/weezjs-core";
import Event from "models/event";
import useOrganizationContext from "../../hooks/useOrganizationContext";

const getEventList = (organizationId, params) => {
	return fetcher.get(`/bo/organizers/${organizationId}/events/`, {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	});
};

const useEventList = ({ params = null, options = {} } = {}) => {
	const organization = useOrganizationContext();
	const organizationId = organization?.id();

	params = {
		ordering: "-pk",
		is_closed: "None",
		...params
	};
	return useQuery(
		["event-list", organizationId, params],
		() =>
			getEventList(organizationId, params).then(response => {
				return response;
			}),
		{
			...options,
			enabled: (options?.enabled ?? true) && Boolean(organizationId),
			select: data => {
				return data.response.map(Event.buildFromJSON);
			}
		}
	);
};

export default useEventList;
